export default {
    path: 'review',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/common/CommonList'),
    meta: {title:'结1算审核'}
}